import { render } from "./App.vue?vue&type=template&id=17e4c9fb"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=17e4c9fb&lang=css"

import exportComponent from "/Users/zonk/dev/projects/scoretrack-ionic-v7/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__